// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  outline: none;
  vertical-align: baseline;
}

*:before,
*:after {
  box-sizing: inherit;
}

article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

audio,
video {
  display: inline-block;
}

img {
  border-style: none;
}

a, button, input, textarea, select {
  color: black;
  text-decoration: none;
}

button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

ul, ol {
  list-style-type: none;
}

.font-s-10 {
  font-size: 10px !important;
}

.font-s-12 {
  font-size: 12px !important;
}

.font-s-13 {
  font-size: 13px !important;
}

.font-s-14 {
  font-size: 14px !important;
}

.font-s-15 {
  font-size: 15px !important;
}

.font-s-16 {
  font-size: 16px !important;
}

.font-s-18 {
  font-size: 18px !important;
}

.font-s-20 {
  font-size: 20px !important;
}

.font-s-22 {
  font-size: 22px !important;
}

.font-s-28 {
  font-size: 28px !important;
}

.font-w-400 {
  font-weight: 400 !important;
}

.font-w-500 {
  font-weight: 500 !important;
}

.font-w-600 {
  font-weight: 600 !important;
}

.font-w-700 {
  font-weight: 700 !important;
}

.p-5 {
  padding: 5px !important;
}

.p-12 {
  padding: 12px !important;
}

.p-16 {
  padding: 16px !important;
}

.p-30 {
  padding: 30px !important;
}

.p-b-0 {
  padding-bottom: 0 !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-b-12 {
  padding-bottom: 12px !important;
}

.p-b-16 {
  padding-bottom: 16px !important;
}

.p-b-18 {
  padding-bottom: 18px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

.p-t-0 {
  padding-top: 0 !important;
}

.p-t-12 {
  padding-top: 12px !important;
}

.p-t-16 {
  padding-top: 16px !important;
}

.p-t-18 {
  padding-top: 18px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

.p-l-20 {
  padding-left: 20px !important;
}

.p-l-30 {
  padding-left: 30px !important;
}

.p-l-40 {
  padding-left: 40px !important;
}

.p-r-16 {
  padding-right: 16px !important;
}

.p-r-20 {
  padding-right: 20px !important;
}

.p-r-30 {
  padding-right: 30px !important;
}

.p-r-50 {
  padding-right: 50px !important;
}

.p-r-60 {
  padding-right: 60px !important;
}

.m-b-1 {
  margin-bottom: 1px !important;
}

.m-b-2 {
  margin-bottom: 2px !important;
}

.m-b-6 {
  margin-bottom: 6px !important;
}

.m-b-8 {
  margin-bottom: 8px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-14 {
  margin-bottom: 14px !important;
}

.m-b-16 {
  margin-bottom: 16px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-22 {
  margin-bottom: 22px !important;
}

.m-b-24 {
  margin-bottom: 24px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.m-b-32 {
  margin-bottom: 32px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.m-t-2 {
  margin-top: 2px !important;
}

.m-t-3 {
  margin-top: 3px !important;
}

.m-t-4 {
  margin-top: 4px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-8 {
  margin-top: 8px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-16 {
  margin-top: 16px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-22 {
  margin-top: 22px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-32 {
  margin-top: 32px !important;
}

.m-l-auto {
  margin-left: auto !important;
}

.m-l-4 {
  margin-left: 4px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-6 {
  margin-left: 6px !important;
}

.m-l-8 {
  margin-left: 8px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.m-l-16 {
  margin-left: 16px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.m-l-24 {
  margin-left: 24px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.m-r-8 {
  margin-right: 8px !important;
}

.m-r-10 {
  margin-right: 10px !important;
}

.m-r-16 {
  margin-right: 16px !important;
}

.m-r-20 {
  margin-right: 20px !important;
}

.m-r-24 {
  margin-right: 24px !important;
}

.m-r-30 {
  margin-right: 30px !important;
}

.m-r-40 {
  margin-right: 40px !important;
}

.border-r-3 {
  border-radius: 3px !important;
}

.border-r-4 {
  border-radius: 4px !important;
}

.border-r-6 {
  border-radius: 6px !important;
}

.border-r-10 {
  border-radius: 10px !important;
}

.border-r-12 {
  border-radius: 12px !important;
}

.border-r-16 {
  border-radius: 16px !important;
}

.border-r-50 {
  border-radius: 50% !important;
}

.primary-border {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.primary-border-b {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.primary-border-t {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.primary-border-l {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.primary-border-r {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.secondary-border {
  border: 1px solid #637768;
}

.secondary-border-b {
  border-bottom: 1px solid #637768;
}

.secondary-border-t {
  border-top: 1px solid #637768;
}

.secondary-border-l {
  border-left: 1px solid #637768;
}

.secondary-border-r {
  border-right: 1px solid #637768;
}

.gap-0 {
  gap: 0 !important;
}

.gap-2 {
  gap: 2px !important;
}

.gap-4 {
  gap: 4px !important;
}

.gap-5 {
  gap: 5px !important;
}

.gap-6 {
  gap: 6px !important;
}

.gap-8 {
  gap: 8px !important;
}

.gap-10 {
  gap: 10px !important;
}

.gap-12 {
  gap: 12px !important;
}

.gap-14 {
  gap: 14px !important;
}

.gap-16 {
  gap: 16px !important;
}

.gap-18 {
  gap: 18px !important;
}

.gap-20 {
  gap: 20px !important;
}

.gap-24 {
  gap: 24px !important;
}

.gap-26 {
  gap: 26px !important;
}

.gap-30 {
  gap: 30px !important;
}

.gap-32 {
  gap: 32px !important;
}

.gap-40 {
  gap: 40px !important;
}

.gap-50 {
  gap: 50px !important;
}

.flex-1 {
  flex: 1;
}

.flex-none {
  flex: none !important;
}

.flex-column {
  display: flex;
  flex-direction: column !important;
}

.flex-row {
  display: flex;
  flex-direction: row !important;
}

.vertically-centered {
  display: flex;
  align-items: center !important;
}

.horizontally-centered {
  display: flex;
  justify-content: center !important;
}

.horizontally-end {
  display: flex;
  justify-content: end !important;
}

.vertically-start {
  display: flex;
  align-items: start !important;
}

.space-between {
  display: flex;
  justify-content: space-between !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.height-100 {
  height: 100%;
}

.width-50 {
  width: 50% !important;
}

.width-100 {
  width: 100%;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.absolute-centered {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.fixed {
  position: fixed;
}

.visible {
  opacity: 1;
}

.invisible {
  opacity: 0;
}

.col-90 {
  width: 90% !important;
}

.col-auto {
  width: auto !important;
}

.medical-tabs {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.medical-table-new {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.medical-table-new:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.medical-table-new::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.medical-table-new::-webkit-scrollbar-track {
  display: none;
}
.medical-table-new.no-pagination {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.medical-table-new.no-pagination:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.medical-table-new.no-pagination::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.medical-table-new.no-pagination::-webkit-scrollbar-track {
  display: none;
}

.medical-table-empty {
  padding: 14px 40px !important;
}

.icon-btn {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.search-icon {
  width: 24px;
  height: 24px;
  align-self: center;
}

.disable-select {
  user-select: none;
}

.break-word {
  word-break: break-word;
}

.popup-clear-btn {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.scroll-m-b-20 {
  scroll-margin-bottom: 20px;
}

html {
  font-family: var(--font-family);
}
html body {
  overflow: hidden;
}
html body #root {
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
}

:root {
  --patient-details-header: 68px;
  --top-navigation: 68px;
  --font-family: "Inter", "Source Sans Pro", "Open Sans", sans-serif;
  --tabs-navigation: 21px;
  --secondary-navigation: 47px;
  --patient-details-footer: 54px;
  --table-tabs: 44px;
  --table-pagination: 48px;
  --scheduled-calls-header: 111px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/_reset.scss","webpack://./../common/src/styles/config.scss","webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/_typography.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,wBAAA;ACCF;;ADEA;;EACU,mBAAA;ACEV;;ADAA;;EAC6C,cAAA;ACI7C;;ADFA;;EACQ,qBAAA;ACMR;;ADJA;EAAM,kBAAA;ACQN;;ADNA;EAAqC,YAAA;EAAc,qBAAA;ACWnD;;ADTA;EACE,6BAAA;EACA,YAAA;EACA,eAAA;ACYF;ADVE;EAAa,YAAA;EAAc,mBAAA;ACc7B;;ADXA;EAAS,qBAAA;ACeT;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,0BAAA;AD0CF;;ACvCA;EACE,2BAAA;AD0CF;;ACvCA;EACE,2BAAA;AD0CF;;ACvCA;EACE,2BAAA;AD0CF;;ACvCA;EACE,2BAAA;AD0CF;;ACtCA;EACE,uBAAA;ADyCF;;ACtCA;EACE,wBAAA;ADyCF;;ACtCA;EACE,wBAAA;ADyCF;;ACtCA;EACE,wBAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,8BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,+BAAA;ADyCF;;ACtCA;EACE,yBAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,4BAAA;ADyCF;;ACtCA;EACE,6BAAA;ADyCF;;ACtCA;EACE,6BAAA;ADyCF;;ACtCA;EACE,6BAAA;ADyCF;;ACtCA;EACE,8BAAA;ADyCF;;ACtCA;EACE,8BAAA;ADyCF;;ACtCA;EACE,8BAAA;ADyCF;;ACtCA;EACE,8BAAA;ADyCF;;ACtCA;EACE,8BAAA;ADyCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,8BAAA;ADwCF;;ACrCA;EACE,0BAAA;ADwCF;;ACrCA;EACE,0BAAA;ADwCF;;ACrCA;EACE,0BAAA;ADwCF;;ACrCA;EACE,0BAAA;ADwCF;;ACrCA;EACE,0BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,2BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,4BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACrCA;EACE,6BAAA;ADwCF;;ACpCA;EACE,6BAAA;ADuCF;;ACpCA;EACE,6BAAA;ADuCF;;ACpCA;EACE,6BAAA;ADuCF;;ACpCA;EACE,8BAAA;ADuCF;;ACpCA;EACE,8BAAA;ADuCF;;ACpCA;EACE,8BAAA;ADuCF;;ACpCA;EACE,6BAAA;ADuCF;;ACpCA;EACE,uCAAA;ADuCF;;ACpCA;EACE,8CAAA;ADuCF;;ACpCA;EACE,2CAAA;ADuCF;;ACpCA;EACE,4CAAA;ADuCF;;ACpCA;EACE,6CAAA;ADuCF;;ACpCA;EACE,yBAAA;ADuCF;;ACpCA;EACE,gCAAA;ADuCF;;ACpCA;EACE,6BAAA;ADuCF;;ACpCA;EACE,8BAAA;ADuCF;;ACpCA;EACE,+BAAA;ADuCF;;ACnCA;EACE,iBAAA;ADsCF;;ACnCA;EACE,mBAAA;ADsCF;;ACnCA;EACE,mBAAA;ADsCF;;ACnCA;EACE,mBAAA;ADsCF;;ACnCA;EACE,mBAAA;ADsCF;;ACnCA;EACE,mBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,oBAAA;ADsCF;;ACnCA;EACE,OAAA;ADsCF;;ACnCA;EACE,qBAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,iCAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,8BAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,8BAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,kCAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,+BAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,6BAAA;ADsCF;;ACnCA;EACE,aAAA;EACA,yCAAA;ADsCF;;ACnCA;EACE,0BAAA;ADsCF;;AClCA;EACE,YAAA;ADqCF;;AClCA;EACE,qBAAA;ADqCF;;AClCA;EACE,WAAA;ADqCF;;ACjCA;EACE,eAAA;ADoCF;;ACjCA;EACE,8BAAA;ADoCF;;AChCA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ADmCF;;AChCA;EACE,kBAAA;ADmCF;;AChCA;EACE,kBAAA;ADmCF;;AChCA;EACE,eAAA;ADmCF;;AC/BA;EACE,UAAA;ADkCF;;AC/BA;EACE,UAAA;ADkCF;;AC9BA;EACE,qBAAA;ADiCF;;AC9BA;EACE,sBAAA;ADiCF;;AC7BA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ADgCF;;AC7BA;EC5lBE,wLD8lBE;EC7lBF,kBAAA;EACA,kBAAA;AF6nBF;AE3nBE;EACE,oCAAA;EACA,mBAAA;AF6nBJ;AE1nBE;EACE,UAAA;EACA,6BAAA;AF4nBJ;AEznBE;EACE,aAAA;AF2nBJ;ACrCE;ECrmBA,8JDumBI;ECtmBJ,kBAAA;EACA,kBAAA;AF6oBF;AE3oBE;EACE,oCAAA;EACA,mBAAA;AF6oBJ;AE1oBE;EACE,UAAA;EACA,6BAAA;AF4oBJ;AEzoBE;EACE,aAAA;AF2oBJ;;AC1CA;EACE,6BAAA;AD6CF;;ACzCA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AD4CF;;ACzCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AD4CF;;ACzCA;EACE,iBAAA;AD4CF;;ACzCA;EACE,sBAAA;AD4CF;;ACzCA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AD4CF;;ACzCA;EACE,0BAAA;AD4CF;;AGvsBA;EACE,+BCEO;AJwsBT;AGxsBE;EACE,gBAAA;AH0sBJ;AGxsBI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AH0sBN;;AAntBA;EACE,8BAAA;EACA,sBAAA;EACA,kEAAA;EACA,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;EACA,+BAAA;AAstBF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  outline: none;\n  vertical-align: baseline;\n}\n\n*:before,\n*:after { box-sizing: inherit; }\n\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section { display: block; }\n\naudio,\nvideo { display: inline-block; }\n\nimg { border-style: none; }\n\na, button, input, textarea, select { color: black; text-decoration: none; }\n\nbutton {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n\n  &:disabled { opacity: 0.5; cursor: not-allowed; }\n}\n\nul, ol { list-style-type: none; }\n","@forward 'reset';\n@forward 'typography';\n\n:root {\n  --patient-details-header: 68px;\n  --top-navigation: 68px;\n  --font-family: 'Inter', 'Source Sans Pro', 'Open Sans', sans-serif;\n  --tabs-navigation: 21px;\n  --secondary-navigation: 47px;\n  --patient-details-footer: 54px;\n  --table-tabs: 44px;\n  --table-pagination: 48px;\n  --scheduled-calls-header: 111px;\n}\n","@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@forward 'global/index';\n@use 'global/fonts';\n\nhtml {\n  font-family: fonts.$roboto;\n\n  body {\n    overflow: hidden;\n\n    #root {\n      height: 100%;\n      min-height: 100vh;\n      overflow: hidden;\n    }\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
